module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rfJT1y/images/cover.jpg?1685327251871",
      "alt": "This image is the cover for the book Love on the Rocks, Bar Tenders"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Love on the Rocks, Bar Tenders\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Another Bar Tender Tale")])])]), _c('p', [_vm._v("Twenty-six-year-old barman and cabaret entertainer Justin has recently moved to London for a fresh start. Charismatic and flirty, Justin is naturally the center of attention wherever he goes. There’s only one problem: the object of Justin’s affections, a handsome, enigmatic bartender named Yena, isn’t won over by Justin’s charm. In fact, he flat out turns Justin down.")]), _vm._v(" "), _c('p', [_vm._v("Stripping off his showmanship frills and charms, Justin aims for a different approach: reveal himself for who he is. Underneath his public face Justin is an honest young man who wants someone special to share his time with… and laugh at his awful jokes.")]), _vm._v(" "), _c('p', [_vm._v("Justin can only hope the real him is irresistible to the man he loves.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melanie Tushmore\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0